import { useState, useEffect } from 'react';
import { API_URL } from "../../shared/constant";
import { Oval } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import Swal from "sweetalert2";

const OrderPermission = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState([]);
    const [formData, setFormData] = useState({
        user_id: "",
    });

    const fetchOptions = async (inputValue) => {
        if (inputValue && inputValue.length > 2) {
            try {
                const res = await axios.post(API_URL.USERS_SEARCH, { text: inputValue });
                return res.data.map((user) => ({
                    label: user.name,
                    value: user.id,
                }));
            } catch (error) {
                console.error('API fetch error:', error);
                return [];
            }
        } else {
            return [];
        }
    };

    const getUser = () => {
        setLoading(true);
        axios.post(API_URL.USERS_DIRECT, {}).then(
            (res) => {
                if (res.data.status === 1) {
                    setUserData(res.data.data);
                }
                setLoading(false);
            },
            (error) => {
                setLoading(false);
                toast.error("Something went wrong..", {
                    autoClose: 3000,
                    
                });
            }
        );
    };


    const adduser = () => {
            setLoading(true);
            axios.post(API_URL.USERS_ADD_DIRECT, {
                user_id: formData.user_id,
            })
                .then((res) => {
                    if (res.data.status === 1) {
                        let message = "Permission added";
                        toast.success(message, { autoClose: 3000, position: "top-right" });
                        setLoading(false);
                        getUser();
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
    };

    const deleteParty = (row) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to remove permission for user " + row.name,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.post(API_URL.USERS_REMOVE_DIRECT, { user_id: row.user_id }).then(
                    (res) => {
                        if (res.data.status === 1) {
                            let newData = userData.filter((r) => r.user_id != row.user_id);
                            setUserData(newData);
                        }
                        toast.success("Permission removed successfully", {
                            autoClose: 3000
                        });
                        setLoading(false);
                    },
                    (error) => {
                        setLoading(false);
                        toast.error("Something went wrong..", {
                            autoClose: 3000,
                            
                        });
                    }
                );
            }
        });
    };

    const handleChange = (option) => {
        setSelectedOption(option);
        const selectedId = option ? option.value : "";
        setFormData({ user_id: selectedId });
    };


    useEffect(() => {
        getUser();
    }, []);

    return (
        <div className="row">
            <div className="col-6">
                <h1>Order Permission</h1>
            </div>
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header">Order Settings</div>
                    <div className="card-body">
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Who can send you direct order</label>
                                    <AsyncSelect
                                        cacheOptions
                                        loadOptions={fetchOptions}
                                        defaultOptions
                                        onChange={handleChange}
                                        value={selectedOption}
                                        placeholder="Search User...."
                                        isClearable
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                borderColor: '#ccc',
                                                boxShadow: 'none',
                                                '&:hover': { borderColor: '#aaa' },
                                            }),
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <button
                                    onClick={() => adduser()}
                                    className="btn btn-primary"
                                >
                                    <i className="fa fa-plus me-1"></i> Add
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-sm-12 pt-3">
                <div className="card">
                    <div className="card-body p-0">
                        {loading ? (
                            <Oval
                                height={60}
                                width={60}
                                color="#7539ff"
                                wrapperStyle={{ justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel="oval-loading"
                                secondaryColor="#7539ff"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                            />
                        ) : (
                            <div className="table-responsive">
                                <table className="table">
                                    <thead className="">
                                        <tr>
                                            <th>Name</th>
                                            <th>Contact No</th>
                                            <th>Address</th>
                                            <th>City</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userData.map((row, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td>
                                                        {row.name}
                                                    </td>
                                                    <td>{row.contact_no}</td>
                                                    <td>{row.address}</td>
                                                    <td>{row.city_name}, {row.state_name}</td>
                                                    <td>
                                                        <button
                                                            onClick={() => deleteParty(row)}
                                                            className="btn btn-sm btn-danger me-2"
                                                        >
                                                            <i className="fa fa-trash me-1"></i> Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderPermission;
